const React = require('react');
const {AdminSubtitle, AdminFormRow, AdminFormCol} = require('../../../../../dumb/AdminHelpers/AdminLayout');

const BalanceCard = require('./components/BalanceCard');

module.exports = () => {
  const fiatDefaultValues = {balance: '30000.123', available: '28108.54', reserved: '1000.00'};
  const cryptoDefaultValues = {balance: '29108.54', available: '29000.123', reserved: '1000.00'};

  const fiats = ['USD', 'EUR', 'GBR', 'CHF'].map((symbol) => ({symbol, ...fiatDefaultValues}));
  const cryptos = ['BTC', 'ETH', 'USDT', 'USDC'].map((symbol) => ({symbol, ...cryptoDefaultValues}));

  return (
    <AdminFormRow className="mt33">
      <AdminFormCol>
        <div className="mb27">
          <AdminSubtitle text="Fiat Balance" />
        </div>
        {fiats.map((el, id) => (
          <div key={id} className="mt10">
            <BalanceCard {...el} />
          </div>
        ))}
      </AdminFormCol>
      <AdminFormCol>
        <div className="mb27">
          <AdminSubtitle text="Crypto Balance" />
        </div>
        {cryptos.map((el, id) => (
          <div key={id} className="mt10">
            <BalanceCard {...el} reverse />
          </div>
        ))}
      </AdminFormCol>
    </AdminFormRow>
  )
}
